





























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditConfig from '@/components/groupCarac/edit/EditConfig.vue'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadConfig',    
  components:{EditConfig},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    groupCarac:{
      type:Object,
      default:getDefaultAloGroupCarac()
    },  
    editable:{
      type:Boolean,
      default:true      
    } 
  }
})
export default class ReadConfig extends Vue {
  
  private groupCarac!:AloGroupCarac
  private loading!:boolean  
  private editable!:boolean  

  edit() { 
    (this.$refs.editConfig as EditConfig).edit(this.groupCarac)
  }

}
